import React from "react";
import PropTypes from "prop-types";

import "../styles/numberGridBicho.scss";
import Icon from "./layout/icon";
import NumberBicho from "./layout/numberBicho";

export default class NumberGridBicho extends React.Component {
  constructor(props) {
    super(props);

    /**
     * @type {{
     *  array: number,
     *  sectionLength: number,
     *  selections: number[],
     *  onSelect: () => void,
     *  onDeselect: () => void,
     *  disabledNumbers: number[],
     * allowMultiSelection: boolean,
     * onDeselectNumber: () => void,
     * }}
     */
    this.props;

    const { array: numberArray, sectionLength } = props;

    /**
     * @type {{
     *  numbers: number[],
     *  start: number,
     *  end: number,
     *  active: false,
     * }[]}
     */
    const sectionedNumberArrays = numberArray.reduce(
      (newArray, currentNumber, index) => {
        let sectionIndex = Math.floor(index / sectionLength);

        if (sectionIndex >= newArray.length) {
          const nextSection = {
            numbers: [],
            start: currentNumber,
            end:
              Math.min(numberArray.length, currentNumber + sectionLength) - 1,
            active: false,
          };

          const currentSection = newArray[newArray.length - 1];

          if (nextSection.start === nextSection.end) {
            if (currentSection) {
              currentSection.end++;
              sectionIndex--;
            }
          } else {
            newArray.push(nextSection);
          }
        }

        if (newArray[sectionIndex])
          newArray[sectionIndex].numbers.push(currentNumber);
        return newArray;
      },
      []
    );

    /**
     * @type {{
     *  sections: {
     *      numbers: number[],
     *      start: number,
     *      end: number,
     *      active: boolean
     *  }[],
     *  allSections: {
     *      numbers: number[],
     *      start: number,
     *      end: number,
     *      active: boolean
     *  }[],
     *  shouldDivideInSections: boolean
     * }}
     */
    this.state = {
      sections: sectionedNumberArrays,
      allSections: [
        {
          numbers: numberArray,
          start: 0,
          end: numberArray.length - 1,
          active: true,
        },
      ],
      shouldDivideInSections: true,
    };
  }

  render() {
    const {
      array: numberArray,
      onSelect,
      disabledNumbers,
      allowMultiSelection,
      selections,
      onDeselectNumber,
    } = this.props;

    return (
      <div className="number-bicho-grid">
        {numberArray.map(number => {

          const isSelected = selections.includes(number);

          return (
            <React.Fragment>
              <NumberBicho
                onClick={() => {
                  onSelect(number);

                  if (isSelected && !allowMultiSelection) {
                    onDeselectNumber(number);
                  }
                }}
                selected={isSelected}
                disabled={disabledNumbers[number]}
                number={number}
                showAnimal={true}
              >
              </NumberBicho>
            </React.Fragment>
          );
        })}
      </div>
    );
  }

  toggleSection(sectionIndex) {
    const allSections = this.state.sections;
    const section = allSections[sectionIndex];
    section.active = !section.active;

    this.setState({
      ...this.state,
    });
  }

  toggleAllSections() {
    this.setState({
      ...this.state,
      shouldDivideInSections: !this.state.shouldDivideInSections,
    });
  }
}

NumberGridBicho.propTypes = {
  array: PropTypes.arrayOf(PropTypes.number),
  selections: PropTypes.arrayOf(PropTypes.number),
  onSelect: PropTypes.func,
  onDeselect: PropTypes.func,
  sectionLength: PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/rifa/components/numberGridBicho.jsx